import round from 'lodash/round';

export const convertMetersToCentimeters = (meters: number) => round(meters * 100);

export const convertCentimetersToMeters = (centimeters: number) => round(centimeters / 100, 2);

export { deepNullToUndefined, getSizedImageUrl } from '@bodilenergy/util';
